import { translate } from "../../translations";
import { SessionStatus } from "../../types";

export default function StudentWaitingScreen({
  status,
}: {
  status: SessionStatus;
}) {
  return (
    <div className="voting-session__content">
      <h2 className="voting-session__title">
        <span className="--highlighted">
          {translate([
            "student",
            "session",
            status === SessionStatus.Draft ? "waitToStart" : "waitNextQuestion",
          ])}
        </span>
      </h2>

      <div className="voting-session__waiting waiting">
        <span className="waiting__dot"></span>
        <span className="waiting__dot"></span>
        <span className="waiting__dot"></span>
        <span className="waiting__dot"></span>
      </div>
    </div>
  );
}
